import StatikSystem from './StatikSystem'
import Lastfall from './Lastfall'

/**
 * Gaußsches Eliminationsverfahren zur Berechnung des Systems. Alternativ gibt es noch schnellere Verfahren die z.B. eine Bandstruktur und die Symmetrie der Matrix ausnutzen. 
 * Zur besseren Veranschaulichung werden diese nicht verwendet. Aufgrund der wenigen Freiheitsgrade in den Stabwerken ist das auch nicht notwendig.
 * Schritt 1: rechte Seite in die Matrix aufnehmen. (erweiterte Koeffizientenmatrix)
 * Schritt 2: Sortieren der Zeilen um die betragsmäßig größten Werte auf der Hauptdiagonalen nach oben zu sortieren. Dadurch wird verhindert, dass das Pivotelement 0 sein könnte. Zudem wird das Teilen durch kleine Werte verhindert und die Berechnung wird "stabiler".
 *            Es wird in der ersten Zeile und ersten Spalte begonnen. Es wird in der aktuell betrachteten Spalte (i) das betragsmäßig größte Element gesucht. Danach wird Die Zeile (maxRow) zu diesem Wert mit der aktuell obersten Zeile (auch i) getauscht.
 *            danach werden alle Werte der aktuell betrachteten Spalte (i), die unter der Zeile (i) liegen auf 0 gesetzt. Es entsteht die Dreiecksform.
 * Schritt 3: Lösen der Unbekannten durch Rückwärts-Einsetzen
 * 
 * Notiz: Es ist zu beachten, dass zwar die Zeilen vertauscht werden, nicht aber die Spalten, dadurch wird die Reihenfolge der Unbekannten nicht durcheinander gebracht. Die Position im Lösungsvektor kann einfach aus der Hauptdiagonalen geholt werden. 
 * 
 * Verbesserungsvorschlag: es könnte der 2.Teil das Rückwärts Einsetzen in eine separate Funktion ausgelagert werden und eine eigene Funktion zur Kontrolle, ob eine Sigularität vorliegt erstellt werden. das ist zweckmäßig am bessten nach der Umformung in eine Dreiecksmatrix.
 * 
 * @param  {Array} A Matrix die gelöst werden soll
 * @param  {Array} x Rechte Seite des Gleichungssystems
 * @return {Array} retArr Lösungsvektor zurückgeben
 */
function gauss(A, x) {    
    // rechte Seite des Gleichungssystems in die Matrix aufnehmen. Es entsteht die "erweiterte Koeffizientenmatrix"
    x.forEach((value,index)=>{ A[index].push(value) })

    console.table(A)
    const numZeilen = A.length; //Anzahl der Zeilen in der Matrix

    /** Schritt 2:
     * 
     */
    //Schleife über alle Zeilen der Matrix. Dabei entspricht die Zeile auch gleich der Nummer der Unbekannten
    for (let cUnbek=0; cUnbek < numZeilen; cUnbek++) { 
        // Suche das den betragsmäßig größten Wert und die zugehörige Zeile
        var maxEl = Math.abs(A[cUnbek][cUnbek]), //als Startwert wird der Betrag Koeffizenten der aktuellen Unbekannten genommen
            maxRow = cUnbek; //zugehörige Zeilennummer

        // Schleife über alle Zeilen unter der derzeitigen Zeile um zu suchen, ob noch Zeilen mit größeren Werten vorhanden sind.
        // hier wird i auch als Spaltennummer genutzt
        for (let k=cUnbek+1; k < numZeilen; k++) { 
            if (Math.abs(A[k][cUnbek]) > maxEl) {
                maxEl = Math.abs(A[k][cUnbek]);
                maxRow = k;
            }
        }

        // tausche die Zeile mit dem Maximalwert mit der derzeitigen Zeile. Nur wenn die Zeile nicht bereits identisch ist.
        if (maxRow != cUnbek) {
            for (let k=cUnbek; k < numZeilen+1; k++) { 
                var tmp = A[maxRow][k];
                A[maxRow][k] = A[cUnbek][k];
                A[cUnbek][k] = tmp;
            }
        }

        // durch addieren der Zeilen mit dem negativen Vielfachen des Koeffizienten der aktuellen Unbekannten werden die Koeffizienten der folgenden Zeilen für diese Unbekannte zu 0.
        // für bessere Erklärung bitte nach Gauss Elimination im Internet suchen.
        for (let Zeile=cUnbek+1; Zeile < numZeilen; Zeile++) { // Schleife über alle Zeilen unter der aktuellen Zeile
            if (Math.abs(A[cUnbek][cUnbek]) < 1e-5) {
                console.table(A)
                return Promise.reject(new Error('Fehler: Steifigkeitsmatrix ist singulär. Abbruch bei Freiheitsgrad '+ (cUnbek+1)))
            }
            var c = -A[Zeile][cUnbek]/A[cUnbek][cUnbek]; //Berechnen des negativen Vielfachen 
            A[Zeile][cUnbek] = 0 // setze Werte unter der aktuellen Zeile in der aktuellen Spalte auf 0. Das setzen auf 0 ist stabiler als das aufaddieren mit dem negativen Vielfachen, da oft sehr kleine Werte entstehen können.
            
            for (let j=cUnbek+1; j < numZeilen+1; j++) { 
                A[Zeile][j] += c * A[cUnbek][j];   
            }
        }
    }
    if (Math.abs(A[numZeilen-1][numZeilen-1]) < 1e-5){
        console.table(A)
        return Promise.reject(new Error('Fehler: Steifigkeitsmatrix ist singulär. Abbruch bei Freiheitsgrad '+ numZeilen))
    } 
    
    console.table(A)

    /** Schritt 3: Lösen der Gleichungen durch Rückwärts-Einsetzen
     *  Beispiel:
     *   4 x | 3 y | 1 z |    6
     *   0   | 2 y | 2 z |    0
     *   0   | 0   | 7 z |    7
     * 
     * Ruckwärtseinsetzen
     *   1. Unbekannte bestimmen durch dividieren der rechten Seite durch den einzigen Koeffizienten auf der linken Seite in dieser Zeile
     *      7*z=7   =>  z=7/7   =>  z=1
     *   
     *   2. aufbereiten der Zeilen darüber. Die bisherigen Ergenisse werden in jeder Zeile mit den Koeffizienten multipliziert und auf die rechte Seite geholt. Dadurch reduziert sich für jede Zeile die Zahl der Unbekannten um 1. 
     *      4*x+3*y+1=6 =>  4*x+3*y=6-1     =>          4 x | 3 y | 0 |    5
     *      2*y+2*1=0   =>  2*y=0-2*1       =>          0   | 2 y | 0 |   -2
     * 
     *   3. Schritt 1 und 2 werden nun mit der nächst höheren Zeile wiederholt bis alle Unbekannten berechnet sind.
     * 
     */
    let retArr = new Array(x.length) //hier werden die Lösungen gespeichert

    for (let i=numZeilen-1; i > -1; i--) {      // Schleife über alle Zeilen von unten nach oben
        
        retArr[i] = A[i][numZeilen]/A[i][i];    // die Lösung der Zeile ist der Quotient der rechten Seite (A[i][numZeilen]) durch den einzigen verbleibenden Koeffizienten. Dieser liegt auf der Hauptdiagonalen (A[i][i])

        for (let k=i-1; k > -1; k--) {  // rechte Seite für alle Zeilen über der aktuellen Zeile aufbereiten. Einrechnen der bekannten größen um die Unbekannten zu reduzieren.
            A[k][numZeilen] -= A[k][i] * retArr[i];
        }
    }
    return Promise.resolve(retArr)
}

/**
 * neue Matrix erstellen und ggf. mit vordefinierten Werten füllen. 
 * @param  {Integer} numrows Anzahl Reihen
 * @param  {Integer} numcols Anzahl Spalten
 * @param  {Number}  initial Wert für die neuen Zellen
 * @return {Array} Rückgabe der erstellten Matrix
 */
Array.matrix = function(numrows, numcols, initial) {
    var arr = [];
    for (var i = 0; i < numrows; ++i) {
        if (numcols > 0){
            var columns = [];
            for (var j = 0; j < numcols; ++j) {
                columns[j] = initial;
            }
            arr[i] = columns;
        }
        else arr.push(initial)
    }
    return arr;
}

//Sucht den maximalen Wert aus einem Array. Die Funktion verschachtelt sich, damit können auch mehrdimensionale Arrays durchsucht werden.
function getMax(arr){
    return Math.max(...arr.map(e => Array.isArray(e) ? getMax(e) : e))
}

//Sucht den minimalen Wert aus einem Array. Die Funktion verschachtelt sich, damit können auch mehrdimensionale Arrays durchsucht werden.
function getMin(arr){
    return Math.min(...arr.map(e => Array.isArray(e) ? getMin(e) : e))
}

//Sucht den betragsmäßigen maximalen Wert aus einem Array. Die Funktion verschachtelt sich, damit können auch mehrdimensionale Arrays durchsucht werden.
function getAbsMax(arr){
    return Math.max(...arr.map(e => Array.isArray(e) ? getAbsMax(e) : Math.abs(e)));
}

// bereitstellen der Berechnungsfunktion im der StatikSystem Klasse. Dadurch kann die Funktion von der Klasse StatikSystem aufgerufen werden.
StatikSystem.prototype.berechne = berechnen

/**
 * Berechnet das angegebene System für den gegebenen Lastfall.
 * 1.Schritt: den Lastfall als noch nicht berechnet kennzeichnen. Prüfen ob das angegebene System Knoten enthält.
 * 2.Schritt: Ermitteln der Freiheitsgrade des Systems
 * 3.Schritt (Optional): Ermittlung der Bandbreite der entstehenden globalen Steifigkeitsmatrix
 * 4.Schritt: Aufstellen der globalen Systemsteifigkeitsmatrix. ohne Berücksichtigung von Randbedingungen
 * 5.Schritt: eine Kopie der Steifigkeitsmatrix erstellen. Diese Kopie wird durch einarbeiten der Randbedingungen und durch die umformungen beim lösen des Gleichungssystems durcheinander gebracht. 
 * 6.Schritt: Lastvektor aufstellen
 * 7.Schritt: Randbedingungen in die Kopie der Steifigkeitsmatrix einarbeiten
 * 8.Schritt: Kopie der Steifigkeitsmatrix mit eingearbeiteten Randbedingungen erstellen. Diese wird später zur bestimmung der Auflagerkräfte genutzt.
 * 9.Schritt: Gleichungssystem lösen
 * 10.Schritt: 
 * 
 * 
 * 
 * 
 * @param {StatikSystem} system 
 * @param {Lastfall} lastfall 
 */
export async function berechnen(system, lastfall){
    //1.Schritt
    lastfall.Berechnet = false
    if (!this.Knotenliste) return new Error('Knotenliste nicht vorhanden.')
    
    //2.Schritt
    let Freiheitsgrade = await freiheitsgrade(system); console.log('Freiheitsgrade ermittelt. Es gibt ' + Freiheitsgrade + ' Freiheitsgrade' )
    
    //3.Schritt (Optional)
    // Bandbreite wird nicht benötigt, könnte jedoch für eine effizientere Berechnungsmethode verwendet werden. 
    // let Bandbreite = await bandbreite(system, Freiheitsgrade); console.log('Bandbreite ermittelt')
        
    //4.Schritt
    let G_Matrix = await gMatrix(system, Freiheitsgrade); console.log('gMatrix aufgestellt.'); console.table(G_Matrix)
    
    //5.Schritt: Erstellen einer Kopie (deep Copy) der Systemsteifigkeitsmatrix, da diese beim Einbau der Randbedingungen "vermurxt" wird.
    let G_Matrix_copy = G_Matrix.map((row)=>{return row.slice()}); console.log('gMatrix_copy erstellt.')

    //6.Schritt
    let Lastvektor = await lastvektor(lastfall, Freiheitsgrade); console.log('Lastvektor aufgestellt.',Lastvektor)
    
    //7.Schritt
    G_Matrix_copy = await randbedingungen(system, G_Matrix_copy); console.log('Randbedingungen eingearbeitet'); console.table(G_Matrix_copy)
    
    //8.Schritt
    let G_matrix_auflager_copy = G_Matrix_copy.map((row)=>{return row.slice()})
    
    //9.Schritt: Gleichungssystem lösen.
    lastfall.Ergebnisvektor = await gauss(G_Matrix_copy, Lastvektor)
    
    //10.Schritt: Kontrolle der Ergebnisse
    let Kontrolle = await ErgebnisBewertung(system,lastfall.Ergebnisvektor)
    if (!Kontrolle) Kontrolle = confirm('Es wurden sehr große Verformungen ermittelt, das System ist evtl. Labil. Sollen die Ergebnisse dennoch gezeigt werden?')
    if (Kontrolle){
        console.log('Knotenverschiebungen berechnet.')
        console.table(lastfall.Ergebnisvektor)
        console.log('Auflagerreaktionen:',await auflagerreaktionen(system, lastfall, G_matrix_auflager_copy))
        Stabschnittkräfte(system, lastfall)
        console.log('Es wurde alles Berechnet!')
        console.log('Schnittkräfte',lastfall.Schnittkräfte)
        return true
    }
    else  {
        // Verschiebungen sind sehr groß. Berechnung vermutlich am verschieblichen System.
        return false
    }
}

/**
 * Funktion zur Ermittlung der Bandbreite der Systemsteifigkeitsmatrix. wird zur Berechnung nicht zwingend benötigt. Damit könnte man jedoch für sehr große Systeme die Matrix effizienter abspreichern und auch berechnen.
 * zur besseren Veranschaulichung, Überprüfung, Debugging ...  wird darauf verzichtet und die Steifigkeitsmatrix wird voll ausgeschrieben.
 * 
 * @param {StatikSystem} system 
 * @param {Integer} freiheitsgrade 
 */
function bandbreite(system, freiheitsgrade){
    return new Promise((resolve, reject)=>{
        // Abfrage ob Stäbe vorhanden sind
        if (system.Stabliste.length == 0) return reject(new Error('Fehler bei der Ermittlung der Bandbreite. Keine Stäbe vorhanden'))
        let Bandbreite = 0
        let val = 0
        system.Stabliste.forEach(curStab =>{
            // unteren und oberen Grenzwert für die Bandbreite 
            let a = 1; let b = freiheitsgrade
            curStab.Freiheitsgrade.forEach(curStabende =>{
                curStabende.forEach(curFreiheitsgrad=>{
                    val = curFreiheitsgrad
                    if(val != 0){
                        a = val > a ? val : a
                        b = val < b ? val : b
                    }
                })
            })
            val = a - b + 1
            Bandbreite = val > Bandbreite ? val : Bandbreite
        })
        if (Bandbreite == 0) return reject(new Error('Die Bandbreite der Steifigkeitsmatrix ist 0. Evtl. muss ein zwischenknoten eingefügt werden.'))
        return resolve(Bandbreite)
    })
}

/**
 * 
 * @param {StatikSystem} system 
 */
function freiheitsgrade(system){
    return new Promise((resolve, reject)=>{
        let Freiheitsgrade = 0
        if (system.Stabliste.length == 0) return reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Keine Stäbe vorhanden'))
        // Schleife über alle Knoten
        system.Knotenliste.forEach(curKnoten =>{
            if (curKnoten.Stabliste.length == 0) return reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Knoten Nr. '+ curKnoten.number +' ohne Stäbe')) 

            // Freiheitsgrade des Knotens festlegen
            for (let k = 0;k <= 2; k++){
                Freiheitsgrade ++
                curKnoten.Freiheitsgrade[k] = Freiheitsgrade
            }


            let deltaFreiheitsgrade = 0
            // Schleife über 3 mögliche Freiheitsgrade
                                                                    // for (let k = 0;k <= 2; k++){
                                                                    //     Freiheitsgrade ++
            // Schleife über alle Stäbe am curKnoten
            curKnoten.Stabliste.forEach(curStab =>{
                if(curStab.StartKnoten === curKnoten){
                    // Wenn am Stabende kein Gelenk vorhanden ist
                    if (curStab.StartGelenk === null){
                        for (let k = 0;k <= 2; k++){
                            curStab.Freiheitsgrade[0][k] = curKnoten.Freiheitsgrade[k]
                        }
                    }else { // Wenn am Stabende ein Gelenk vorhanden ist entstehen 3 zusätzliche Freiheitsgrade. Jedoch nur für den betroffenen Stab.
                        for (let k = 0;k <= 2; k++){
                            deltaFreiheitsgrade ++
                            curStab.Freiheitsgrade[0][k] = Freiheitsgrade + deltaFreiheitsgrade
                        }
                    }
                }else if (curStab.EndKnoten === curKnoten){
                    // Wenn am Stabende kein Gelenk vorhanden ist
                    if (curStab.EndGelenk === null){
                        for (let k = 0;k <= 2; k++){
                            curStab.Freiheitsgrade[1][k] = curKnoten.Freiheitsgrade[k]
                        }
                    }else { // Wenn am Stabende ein Gelenk vorhanden ist entstehen 3 zusätzliche Freiheitsgrade. Jedoch nur für den betroffenen Stab.
                        for (let k = 0;k <= 2; k++){
                            deltaFreiheitsgrade ++
                            curStab.Freiheitsgrade[1][k] = Freiheitsgrade + deltaFreiheitsgrade
                        }
                    }
                }else reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Knoten Nr. '+ curKnoten.number + ' passt nicht zum Stab Nr. '+ curStab.number))
            })
            Freiheitsgrade += deltaFreiheitsgrade
                                                                                    // }
        })
        console.log('Es wurden '+Freiheitsgrade+' Freiheitsgrade ermittelt.')
        resolve(Freiheitsgrade)
    })
}




// function freiheitsgrade_alt(system){
//     return new Promise((resolve, reject)=>{
//         let Freiheitsgrade = 0
//         if (system.Stabliste.length == 0) return reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Keine Stäbe vorhanden'))
//         // Schleife über alle Knoten
//         system.Knotenliste.forEach(curKnoten =>{
//             if (curKnoten.Stabliste.length == 0) return reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Knoten Nr. '+ curKnoten.number +' ohne Stäbe'))     
//             let deltaFreiheitsgrade = 0
//             // Schleife über 3 mögliche Freiheitsgrade
//             for (let k = 0;k <= 2; k++){
//                 Freiheitsgrade ++
//                 // Schleife über alle Stäbe am curKnoten
//                 curKnoten.Stabliste.forEach(curStab =>{
//                     if(curStab.StartKnoten === curKnoten){
//                         // Wenn am Stabende kein Gelenk vorhanden oder wenn das Gelenk an der Stelle Starr ist
//                         if (curStab.StartGelenk === null || curStab.StartGelenk.Werte[k] == -1){
//                             curStab.Freiheitsgrade[0][k] = Freiheitsgrade
//                             curKnoten.Freiheitsgrade[k] = Freiheitsgrade
//                         }else {
//                             // Durch das Gelenk entsteht ein zusätzlicher Freiheitsgrad. Jedoch nur für den betroffenen Stab.
//                             curKnoten.Freiheitsgrade[k] = Freiheitsgrade
//                             deltaFreiheitsgrade ++
//                             curStab.Freiheitsgrade[0][k] = Freiheitsgrade + deltaFreiheitsgrade
//                         }
//                     }else if (curStab.EndKnoten === curKnoten){
//                         // Wenn am Stabende kein Gelenk vorhanden oder wenn das Gelenk an der Stelle Starr ist
//                         if (curStab.EndGelenk === null || curStab.EndGelenk.Werte[k] == -1){
//                             curStab.Freiheitsgrade[1][k] = Freiheitsgrade
//                             curKnoten.Freiheitsgrade[k] = Freiheitsgrade
//                         }else {
//                             // Durch das Gelenk entsteht ein zusätzlicher Freiheitsgrad. Jedoch nur für den betroffenen Stab.
//                             curKnoten.Freiheitsgrade[k] = Freiheitsgrade
//                             deltaFreiheitsgrade ++
//                             curStab.Freiheitsgrade[1][k] = Freiheitsgrade + deltaFreiheitsgrade
//                         }
//                     }else reject(new Error('Fehler bei der Ermittlung der Freiheitsgrade. Knoten Nr. '+ curKnoten.number + ' passt nicht zum Stab Nr. '+ curStab.number))
//                 })
//                 Freiheitsgrade += deltaFreiheitsgrade
//             }
//         })
//         console.log('Es wurden '+Freiheitsgrade+' Freiheitsgrade ermittelt.')
//         resolve(Freiheitsgrade)
//     })
// }











function gMatrix(system, freiheitsgrade){
    // globale Steifigkeitsmatrix aufbauen.
    // Es werden alle Stäbe abgearbeitet und je Stab wird jeder Freiheitsgrad abgearbeitet.
    // Die Steifigkeit vom Freiheitsgrad des Stabes wird zur zugehörigen Steifigkeit des globalen Freiheitsgrades addiert.
    let G_Matrix = new Array.matrix(freiheitsgrade,freiheitsgrade, 0)
    return new Promise((resolve, reject)=>{
        system.Stabliste.forEach(curStab =>{
            let StabZeile = 0
            curStab.Freiheitsgrade.forEach(curStabende =>{
                curStabende.forEach(curFreiheitsgrad=>{
                    StabZeile ++
                    let Zeile = curFreiheitsgrad
                    if (Zeile > 0){
                        for (let i = 0; i < 6; i++){
                            // Wenn i = 3 wird das andere Stabende bearbeitet
                            let Spalte = curStab.Freiheitsgrade[i < 3 ? 0 : 1][i < 3 ? i : i-3]
                            G_Matrix[Zeile-1][Spalte-1] += curStab.Elementsteifigkeit_global(StabZeile, i+1)
                        }
                    }
                })
            })       


        })

        let max = getMax(G_Matrix)
        let min = getMin(G_Matrix)
        let abs = Math.abs(min) > Math.abs(max) ? Math.abs(min) : Math.abs(max)

        let offset1Freiheitsgrad_Gelenkelement = null
        let offset2Freiheitsgrad_Gelenkelement = null
        let curGelenk = undefined
        let i = null
        let k = null 
        let Zeile = null
        let Spalte = null 

        system.Stabliste.forEach(curStab =>{
            if (!(curStab.StartGelenk === null)){
                curGelenk = curStab.StartGelenk
                // GelenkElement liegt zwischen Knoten und Stabanfang
                offset1Freiheitsgrad_Gelenkelement = curStab.StartKnoten.Freiheitsgrade[0]
                offset2Freiheitsgrad_Gelenkelement = curStab.Freiheitsgrade[0][0]
                
                for (i = 0; i < 6; i++){
                    Zeile = i < 3 ? offset1Freiheitsgrad_Gelenkelement+i : offset2Freiheitsgrad_Gelenkelement+i-3
                    for (k = 0; k < 6; k++){
                        Spalte = k < 3 ? offset1Freiheitsgrad_Gelenkelement+k : offset2Freiheitsgrad_Gelenkelement+k-3
                        G_Matrix[Zeile-1][Spalte-1] += curGelenk.Elementsteifigkeit_global(i+1,k+1,curStab,abs)
                    }
                }
            }

            if (!(curStab.EndGelenk === null)){

                curGelenk = curStab.EndGelenk
                // GelenkElement liegt zwischen Stabende und Knoten
                offset1Freiheitsgrad_Gelenkelement = curStab.Freiheitsgrade[1][0]
                offset2Freiheitsgrad_Gelenkelement = curStab.EndKnoten.Freiheitsgrade[0]
                
                for (i = 0; i < 6; i++){
                    Zeile = i < 3 ? offset1Freiheitsgrad_Gelenkelement+i : offset2Freiheitsgrad_Gelenkelement+i-3
                    for (k = 0; k < 6; k++){
                        Spalte = k < 3 ? offset1Freiheitsgrad_Gelenkelement+k : offset2Freiheitsgrad_Gelenkelement+k-3
                        G_Matrix[Zeile-1][Spalte-1] += curGelenk.Elementsteifigkeit_global(i+1,k+1,curStab,abs)
                    }
                }
            }

        })
        
        resolve(G_Matrix)

    })
}

function lastvektor(lastfall, freiheitsgrade){
    let Lastvektor = new Array.matrix(freiheitsgrade, 0, 0)
    return new Promise((resolve, reject) =>{
        // Knotenlasten
        if (lastfall.Knotenlastliste.length > 0){
            lastfall.Knotenlastliste.forEach(Knotenlast =>{
                Knotenlast.Knotenliste.forEach(Knoten =>{
                    Lastvektor[Knoten.Freiheitsgrade[0]-1] += Knotenlast.fX
                    Lastvektor[Knoten.Freiheitsgrade[1]-1] += Knotenlast.fY
                    Lastvektor[Knoten.Freiheitsgrade[2]-1] += Knotenlast.M                
                })
            })
        }
        // Stablasten
        if (lastfall.Stablastliste.length > 0){
            lastfall.Stablastliste.forEach(Stablast =>{
                Stablast.Stabliste.forEach(Stab =>{
                        Lastvektor[Stab.Freiheitsgrade[0][0]-1] += Stablast.ersKnotenlast(Stab,0)
                        Lastvektor[Stab.Freiheitsgrade[0][1]-1] += Stablast.ersKnotenlast(Stab,1)
                        Lastvektor[Stab.Freiheitsgrade[0][2]-1] += Stablast.ersKnotenlast(Stab,2)
                        Lastvektor[Stab.Freiheitsgrade[1][0]-1] += Stablast.ersKnotenlast(Stab,3)
                        Lastvektor[Stab.Freiheitsgrade[1][1]-1] += Stablast.ersKnotenlast(Stab,4)
                        Lastvektor[Stab.Freiheitsgrade[1][2]-1] += Stablast.ersKnotenlast(Stab,5)
                })
            })
        }
        resolve(Lastvektor)
    })
}

function randbedingungen(system, gMatrix){
    const starre_Lagerung = "Var1"
    return new Promise((resolve, reject) =>{
    let max = getMax(gMatrix)
    let min = getMin(gMatrix)
    let abs = Math.abs(min) > Math.abs(max) ? Math.abs(min) : Math.abs(max)
    console.log('max:',abs)
    // Auflager
    // starre Lagerung Var1: es wird das Hauptdiagonalenelement um ein vielfaches vergrößert.
        if (starre_Lagerung == "Var1"){
            system.Knotenliste.forEach(Knoten =>{
                if (Knoten.Auflager != null){
                    Knoten.Auflager.Werte.forEach((Haltung,index) =>{
                        if (Haltung == -1){ // starres Auflager
                            gMatrix[Knoten.Freiheitsgrade[index]-1][Knoten.Freiheitsgrade[index]-1] = abs * 10e10
                        } 
                        else { // Federsteifigkeit oder freies Lager
                            gMatrix[Knoten.Freiheitsgrade[index]-1][Knoten.Freiheitsgrade[index]-1] += Haltung
                        }
                    })
                }
            })
        }
       
        // starre Lagerung Var2: zum Schluss einbauen, da Zeilen und Spalten gestrichen werden; diese Variante wurde entfernt
            // if (starre_Lagerung == "Var2"){
            //     system.Knotenliste.forEach(Knoten =>{
        
            //     })
            // }

        // // let max = getMax(G_Matrix)
        // // let min = getMin(G_Matrix)
        // // let abs = Math.abs(min) > Math.abs(max) ? Math.abs(min) : Math.abs(max)

        // let offset1Freiheitsgrad_Gelenkelement = null
        // let offset2Freiheitsgrad_Gelenkelement = null
        // let curGelenk = undefined
        // let i = null
        // let k = null 
        // let Zeile = null
        // let Spalte = null 

        // system.Stabliste.forEach(curStab =>{
        //     debugger

        //     if (!(curStab.StartGelenk === null)){
        //         curGelenk = curStab.StartGelenk
        //         // GelenkElement liegt zwischen Knoten und Stabanfang
        //         offset1Freiheitsgrad_Gelenkelement = curStab.StartKnoten.Freiheitsgrade[0]
        //         offset2Freiheitsgrad_Gelenkelement = curStab.Freiheitsgrade[0][0]
                
        //         for (i = 0; i < 6; i++){
        //             Zeile = i < 3 ? offset1Freiheitsgrad_Gelenkelement+i : offset2Freiheitsgrad_Gelenkelement+i-3
        //             for (k = 0; k < 6; k++){
        //                 Spalte = k < 3 ? offset1Freiheitsgrad_Gelenkelement+k : offset2Freiheitsgrad_Gelenkelement+k-3
        //                 gMatrix[Zeile-1][Spalte-1] += curGelenk.Elementsteifigkeit_global(i+1,k+1,curStab,abs)
        //             }
        //         }
        //     }

        //     if (!(curStab.EndGelenk === null)){

        //         curGelenk = curStab.EndGelenk
        //         // GelenkElement liegt zwischen Stabende und Knoten
        //         offset1Freiheitsgrad_Gelenkelement = curStab.Freiheitsgrade[1][0]
        //         offset2Freiheitsgrad_Gelenkelement = curStab.EndKnoten.Freiheitsgrade[0]
                
        //         for (i = 0; i < 6; i++){
        //             Zeile = i < 3 ? offset1Freiheitsgrad_Gelenkelement+i : offset2Freiheitsgrad_Gelenkelement+i-3
        //             for (k = 0; k < 6; k++){
        //                 Spalte = k < 3 ? offset1Freiheitsgrad_Gelenkelement+k : offset2Freiheitsgrad_Gelenkelement+k-3
        //                 gMatrix[Zeile-1][Spalte-1] += curGelenk.Elementsteifigkeit_global(i+1,k+1,curStab,abs)
        //             }
        //         }
        //     }

        // })

    // Knoten an denen nur Fachwerkstäbe anschließen gegen Knotenverdrehung halten.
        system.Knotenliste.forEach(Knoten=>{
            let Fachwerkknoten = true
            Knoten.Stabliste.forEach(Stab=>{
                if(Stab.StartKnoten === Knoten){
                    if(Stab.StartGelenk == null || Stab.StartGelenk.Werte[2] != 0) Fachwerkknoten = false
                }
                else if (Stab.EndKnoten === Knoten){
                    if(Stab.EndGelenk == null || Stab.EndGelenk.Werte[2] != 0) Fachwerkknoten = false
                }
            })
            if (Fachwerkknoten) gMatrix[Knoten.Freiheitsgrade[2]-1][Knoten.Freiheitsgrade[2]-1] = abs * 10e20
        })

        resolve(gMatrix)
    })
}

function ErgebnisBewertung(system, Ergebnisvektor){
    return new Promise((resolve, reject) =>{
        let width = system.Bbox.width > 0 ? system.Bbox.width : 100
        let height = system.Bbox.height > 0 ? system.Bbox.height : 100
        Ergebnisvektor.forEach(val =>{
            let cval = Math.abs(val)
            if ( cval > width || cval > height) {
                resolve(false)
            }
        })
        resolve(true)
    })
}

function auflagerreaktionen(system, lastfall, gMatrix){
    return new Promise((resolve, reject)=>{
        system.Knotenliste.forEach(Knoten =>{
            if(Knoten.Auflager != null){
                let curErgebnisse = {
                    Knoten: Knoten,
                    Werte: []
                }
                // lastfall.Auflagerreaktionen['Knoten'+Knoten.number]= {Knoten: Knoten}
                // ---Da die Zeilen und Spalten der gehaltenen Freiheitsgrade nicht gelöscht werden, sondern die Steifigkeiten der Freiheitsgrade
                // sehr hoch angesetzt werden, können die Auflagerkräfte aus der Verschiebung der gehaltenen Knoten und der zugehörigen Steifigkeit ausgerechnet werden.
                for(let i = 0; i < 3;i++){
                    let Wert = 0
                    let Zeile = Knoten.Freiheitsgrade[i]-1
                    let verschiebung = lastfall.Ergebnisvektor[Zeile]
                    switch(Knoten.Auflager.Werte[i]){
                        case -1: // starre Lagerung
                            Wert = -gMatrix[Zeile][Zeile]*verschiebung
                            break
                        case 0: // frei
    
                            break
                        default: // Federsteifigkeit
                        Wert = -Knoten.Auflager.Werte[i]*verschiebung
                    }
                    curErgebnisse.Werte[i] = Math.abs(Wert) < 1e-5 ? 0 : Wert
                }
                lastfall.Auflagerreaktionen.push(curErgebnisse)
            }
        })
        resolve(lastfall.Auflagerreaktionen)
    })


    // ---Folgende Zeilen werden bei einer anderen Berechnungsmethode benötigt. Wenn die Auflagerverschiebungen zu 0 gesetzt werden. 

            // for(let i = 0; i < 3;i++){
            //     let Wert = 0
            //     switch(Knoten.Auflager.Werte[i]){
            //         case -1: // starre Lagerung
            //             let Zeile = Knoten.Freiheitsgrade[i]-1
            //                lastfall.Ergebnisvektor.forEach((verschiebung,index)=>{
            //                    Wert += gMatrix[Zeile][index]*verschiebung
            //                })
            //             break
            //         case 0: // frei

            //             break
            //         default: // Federsteifigkeit

            //     }
            //     lastfall.Auflagerreaktionen['Knoten'+Knoten.number]['Wert'+i] = Wert
            // }


            // lastfall.Knotenlastliste.forEach(curKnotenlast =>{
            //     curKnotenlast.Knotenliste.forEach(curKnoten =>{
            //         if (curKnoten.Auflager) {
            //             //vorerst ohne Auflagerwinkel
            //             curKnoten.Auflager.Werte.forEach((haltung,index) =>{
            //                 switch(haltung){
            //                     case -1: // starre Lagerung
            //                         lastfall.Auflagerreaktionen['Knoten'+curKnoten.number]['Wert'+index] -= curKnotenlast.Werte[index]
            //                         break
            //                     case 0: // frei, hier ist nichts zu tun
            
            //                         break
            //                     default: // Federsteifigkeit
            
            //                 }
            //             })
            //         }
            //     })
            // }) 


            // lastfall.Stablastliste.forEach(Stablast =>{
            //     console.log(Stablast.ersKnotenlast(Knoten, i))
            //     Wert += Stablast.ersKnotenlast(Knoten, i)
            // })
    //
}

function Stabschnittkräfte(system, lastfall){
    return new Promise((resolve, reject)=>{
        lastfall.MaxWerte.N = 0; lastfall.MaxWerte.Q = 0; lastfall.MaxWerte.M = 0; lastfall.MaxWerte.W = 0;
        lastfall.Schnittkräfte.splice(0,lastfall.Schnittkräfte.length)
        system.Stabliste.forEach(Stab =>{
            Stab.Schnittkräfte(lastfall,Stab.Stabteilungen)
        })
        lastfall.Schnittkräfte.forEach(arr=>{
            lastfall.MaxWerte.N = lastfall.MaxWerte.N < getAbsMax(arr.N) ? getAbsMax(arr.N) : lastfall.MaxWerte.N
            lastfall.MaxWerte.Q = lastfall.MaxWerte.Q < getAbsMax(arr.Q) ? getAbsMax(arr.Q) : lastfall.MaxWerte.Q
            lastfall.MaxWerte.M = lastfall.MaxWerte.M < getAbsMax(arr.M) ? getAbsMax(arr.M) : lastfall.MaxWerte.M
            let maxW = getAbsMax(arr.W.map(v => Math.sqrt(v[0]*v[0]+v[1]*v[1])))
            lastfall.MaxWerte.W = lastfall.MaxWerte.W < maxW ? maxW : lastfall.MaxWerte.W
        })
        console.log(lastfall.MaxWerte)
        resolve(lastfall.Schnittkräfte)
    })
}